import React from "react";

export default function TwentyOne({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path d="M253.44,2.69H46.64A11.39,11.39,0,0,0,35.3,14V287.33a11.27,11.27,0,0,0,11.26,11.26H253.44a11.27,11.27,0,0,0,11.26-11.26V14A11.27,11.27,0,0,0,253.44,2.69ZM86.55,261.76v16.93H79.92v-9.61H66.67v9.61H60V261.75H56.56l16.75-14.58L90,261.76Zm173.62-40.52a6.31,6.31,0,0,1-6.32,6.32H46.23a6.3,6.3,0,0,1-6.31-6.32V13.54a6.3,6.3,0,0,1,6.31-6.32H253.85a6.31,6.31,0,0,1,6.32,6.32Z" />
      {children}
    </svg>
  );
}
